import { PaymentsCreateOrderAttributes, PaymentsProduct } from "~/api/Api";

import { Icon } from "../../../assets/icons/Icon";
import { FeatureSection } from "../featureSection/FeatureSection";
import { PricingCard } from "../pricingCard/PricingCard";
import styles from "./ConciergeInstallation.module.scss";

interface ConciergeInstallationProps {
  product: PaymentsProduct;
  targetSites: { value: string; label: string }[];
  createOrder: (order: PaymentsCreateOrderAttributes) => void;
}
const descriptionList = [
  `Software Code installation`,
  `Automation Optimizations Configuration`,
  `Keyword Analysis and Setup`,
  `Money Back Guarantee`,
];
const text = [
  {
    title: "Select target website(s)",
    description: `Just select which site(s) you’d like to order the Concierge service for, and complete your order. We’ll email you to get the site access details.`,
  },
  {
    title: "Let us do the job",
    description: `Our team will begin installing the Alli AI code throughout the site, reviewing and approving the Automation Recommendations, and then we’ll make sure everything is working everywhere and perfectly configured.`,
  },
  {
    title: "Enjoy the result",
    description: `We’ll analyze your Keyword set to make sure you’re tracking and optimizing the optimal keywords to deliver the most, best traffic the fastest.`,
  },
];
const ConciergeInstallation = ({
  product,
  targetSites,
  createOrder,
}: ConciergeInstallationProps) => {
  return (
    <div className={styles.conciergeInstallation}>
      {/* Reordered layout: 1. Reassurance, 2. Price, 3. Process */}
      <div className={styles.conciergeGrid}>
        {/* "Don't worry" Section */}
        <section className={styles.descriptionCard}>
          <div className={styles.descriptionWrapper}>
            <h3 className={styles.descriptionTitle}>
              Don't You Worry About a Thing
            </h3>
            <div className={styles.descriptionContent}>
              <div className={styles.conciergeImage}>
                <Icon
                  iconName="ConciergeInstallationImage"
                  width="19.125rem"
                  height="12.5rem"
                />
              </div>

              <div className={styles.descriptionTextContainer}>
                <p className={styles.descriptionText}>
                  Run into a technical issue while installing the Automation
                  code? Need help setting up site speed optimization through DNS
                  changes? Can't find your way around some archaic CMS? Or maybe
                  you just ran the numbers and decided it's more economical for
                  us to do it.
                </p>
                <p className={styles.descriptionText}>
                  No worries, we'll be happy to help! For $149, we will:
                </p>
                <ul className={styles.descriptionList}>
                  <li>Install and configure any site's code snippet</li>
                  <li>
                    Set up and optimize site speed through DNS configuration
                  </li>
                  <li>
                    Review the Recommendations (excluding any custom text
                    additions)
                  </li>
                  <li>
                    Perform a keyword analysis to make sure you're tracking and
                    optimizing the best keywords possible
                  </li>
                </ul>
                <p className={styles.descriptionText}>
                  Plus, if for some technical reason we can't get the code
                  installed or site speed optimized, we'll refund your setup fee
                  no questions asked.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Pricing Section */}
        <div className={styles.pricingCardContainer}>
          {product.prices?.map((price) => (
            <PricingCard
              key={price.id}
              price={price}
              targetSites={targetSites}
              createOrder={createOrder}
              list={descriptionList}
            />
          ))}
          <div className={styles.guarantee}>
            <h4 className={styles.guaranteeTitle}>Moneyback Guarantee</h4>
            <p className={styles.guaranteeText}>
              If for any reason our team is unable to install and configure the
              Automation software or site speed optimization on a site, we'll
              immediately refund your Concierge Service fee.
            </p>
          </div>
        </div>

        {/* "How It Works" Section */}
        <div className={styles.howItWorksContainer}>
          <FeatureSection
            icon="BrandLinksImage2"
            title="How does it work?"
            text={text}
          />
        </div>
      </div>
    </div>
  );
};

export default ConciergeInstallation;
